<template>
  <form
    id="vacancyRequestForm"
    class="request-create-wrapper"
    @submit.prevent="event => submitForm(event)"
  >
    <div class="request-row">
      <div
        class="request-col"
        :class="{
          'request-opener': matchingActive == true,
          max: matchingActive == false
        }"
      >
        <div class="request-create-col">
          <div v-if="!matchingActive">
            <h3 class="request-create-col-headline">Anfrage erfassen</h3>
            <div class="request-create-category">
              <div class="request-create-category-headline">
                <span>Kategorie</span>
              </div>
              <div class="request-create-category-wrapper">
                <button
                  :class="
                    'request-create-category-button' +
                      (request.category == 'AÜ' ? ' active' : '')
                  "
                  type="button"
                  @click="() => setCategory('AÜ')"
                >
                  AÜ
                </button>
                <button
                  :class="
                    'request-create-category-button' +
                      (request.category == 'PV' ? ' active' : '')
                  "
                  type="button"
                  @click="() => setCategory('PV')"
                >
                  PV
                </button>
              </div>
            </div>
            <div class="request-create-category">
              <div class="request-create-category-headline">
                <span>Bereich</span>
              </div>
              <div class="request-create-category-wrapper">
                <button
                  :class="
                    'request-create-category-button' +
                      (request.section == 'KFM' ? ' active' : '')
                  "
                  type="button"
                  @click="
                    () =>
                      setSection('KFM', 'b7dbc9bb-40a3-4637-8fc0-ccba90a3cd9c')
                  "
                >
                  KFM
                </button>
                <button
                  :class="
                    'request-create-category-button' +
                      (request.section == 'GEW' ? ' active' : '')
                  "
                  type="button"
                  @click="
                    () =>
                      setSection('GEW', 'b7feae77-8cab-4444-a4d2-d7983b17b9eb')
                  "
                >
                  GEW
                </button>
                <button
                  :class="
                    'request-create-category-button' +
                      (request.section == 'TECH' ? ' active' : '')
                  "
                  type="button"
                  @click="
                    () =>
                      setSection('TECH', '2229ec44-1291-4a95-8230-6b1b5658f46d')
                  "
                >
                  TECH
                </button>
                <button
                  :class="
                    'request-create-category-button' +
                      (request.section == 'IT' ? ' active' : '')
                  "
                  type="button"
                  @click="
                    () =>
                      setSection('IT', 'a0919d1d-37c9-445d-a02d-dff70018417e')
                  "
                >
                  IT
                </button>
                <button
                  :class="
                    'request-create-category-button' +
                      (request.section == 'AUS' ? ' active' : '')
                  "
                  type="button"
                  @click="
                    () =>
                      setSection('AUS', '5829d43e-aed6-4cca-b7be-5c9ff6a75fe3')
                  "
                >
                  AUSB
                </button>
              </div>
            </div>
            <hr class="request-create-col-line" />
            <h3 class="request-create-col-headline">Kunde / Interessent</h3>
            <div class="request-create-col-input-wrapper">
              <div class="request-create-col-label">
                Firma <span class="required">*</span>
              </div>
              <DataInput
                v-model="request.companyID"
                type="model"
                class="request-create-col-input"
                name="company"
                model-label="
                    name
                    landwehrId"
                :select-label="
                  el => el.name + ' ' + (el.landwehrId ? '- L1' : '')
                "
                gql-filter-type="objectFilter"
                gql-query="companies"
                gql-single-query="company"
              />
            </div>
            <div class="request-create-col-input-wrapper">
              <div class="request-create-col-label">
                Ansprechpartner <span class="required">*</span>
              </div>
              <DataInput
                v-model="request.companyContactPartnerID"
                type="model"
                class="request-create-col-input"
                name="companyContact"
                model-label="
                  firstName
                  lastName
                "
                :gql-query="contactPartnerQuery"
                gql-single-query="companyContactPartner"
                :select-label="el => `${el.firstName} ${el.lastName}`"
              />
            </div>
          </div>
          <h4 v-if="matchingActive" @click="matchingActive = false">
            Anfrage erfassen
          </h4>
        </div>
      </div>
      <div
        class="request-col"
        :class="{
          large: matchingActive == true,
          'request-opener': matchingActive == false
        }"
      >
        <div class="request-create-col request-job-create">
          <div class="request-job-create-wrapper">
            <h3 class="request-create-col-headline">Stellenentwurf</h3>
            <DataInput
              :initial-value="request.vacancyID"
              :reduce="el => el"
              type="model"
              class="request-create-col-input job-template-select"
              name="vacancy"
              placeholder="Aus Vorlage wählen"
              model-label="
                title
                number"
              :select-label="el => el.title + ' ' + el.number"
              gql-filter-type="objectFilter"
              object-filter-attribute="searchQuery"
              gql-query="vacancyPage"
              gql-single-query="vacancy"
              :model-fields="
                `holidayAndChristmasBonus
              jobEarningLegacy
              takeoverOption
              jobHoursLegacy
              jobTimes{
                id
              }
              project{
                id
                occupation{
                  id
                  name
                  category{
                    id
                  }
                }
              }`
              "
              @input="updateVacancy"
            />
            <!--<table class="selected-job-template">
              <tr>
                <td><b>103921 -</b> Staplerfahrer</td>
                <td class="cancel-wrapper">
                  <span class="cancel"><i class="far fa-times"></i></span>
                </td>
              </tr>
            </table>-->

            <hr class="request-create-col-line" />
            <div>
              <h3 class="request-create-col-headline">Anfrage Details</h3>
              <div class="request-create-col-input-wrapper">
                <div class="request-create-col-label">
                  Titel <span class="required">*</span>
                </div>
                <DataInput
                  v-model="request.title"
                  type="text"
                  class="request-create-col-input"
                  name="vacancyTitle"
                />
              </div>
              <div class="request-create-col-input-wrapper">
                <div class="request-create-col-label">Beginn</div>
                <DataInput
                  v-model="request.startsOn"
                  type="date"
                  class="request-create-col-input"
                  name="contractDate"
                />
              </div>
              <div
                v-if="request.category == 'AÜ'"
                class="request-create-col-input-wrapper"
              >
                <div class="request-create-col-label">Dauer</div>
                <DataInput
                  v-model="request.duration"
                  type="text"
                  class="request-create-col-input"
                  name="contractDate"
                />
              </div>
              <hr class="request-create-col-line" />
            </div>
            <div>
              <h3 class="request-create-col-headline">Stellendetails</h3>
              <div class="request-create-col-input-wrapper">
                <div class="request-create-col-label">Beruf</div>
                <DataInput
                  :initial-value="request.vacancyTemplate.occupationId"
                  :reduce="el => el"
                  :value="request.vacancyTemplate.occupationId"
                  type="model"
                  class="request-create-col-input"
                  name="occupation"
                  gql-query="occupations"
                  :model-fields="'category{\nid\n}'"
                  @input="updateOccupation"
                />
              </div>
              <div
                v-if="request.category == 'AÜ'"
                class="request-create-col-input-wrapper"
              >
                <div class="request-create-col-label">Übernahmeoption</div>
                <DataInput
                  v-model="request.vacancyTemplate.takeOverOption"
                  type="bool"
                  class="request-create-col-input"
                  name="takeoverOption"
                />
              </div>
              <div class="request-create-col-input-wrapper">
                <div class="request-create-col-label">
                  Urlaubs- & Weihnachtsgeld
                </div>
                <DataInput
                  v-model="request.vacancyTemplate.holidayAndChristmasBonus"
                  type="bool"
                  class="request-create-col-input"
                  name="holidayAndChristmasBonus"
                />
              </div>
              <div class="request-create-col-input-wrapper">
                <div class="request-create-col-label">Lohn</div>
                <DataInput
                  v-model="request.vacancyTemplate.salary"
                  type="text"
                  class="request-create-col-input"
                  name="contractDate"
                />
              </div>
              <div class="request-create-col-input-wrapper">
                <div class="request-create-col-label">Wochenarbeitszeit</div>
                <DataInput
                  v-model="request.vacancyTemplate.hoursPerWeek"
                  type="text"
                  class="request-create-col-input"
                  name="jobHoursLegacy"
                />
              </div>
              <div class="request-create-col-input-wrapper">
                <div class="request-create-col-label">Arbeitszeiten</div>
                <DataInput
                  v-model="request.vacancyTemplate.workTimes"
                  type="model"
                  class="request-create-col-input"
                  name="jobTimes"
                  gql-query="vacancyJobTimes"
                />
              </div>
              <hr class="request-create-col-line" />
            </div>
            <div>
              <h3 class="request-create-col-headline">Entfernung</h3>
              <div class="request-create-col-input-wrapper">
                <div class="request-create-col-label">Zu Adresse</div>
                <DataInput
                  v-model="selectedAddress"
                  type="select"
                  :options="
                    addressOptions.map(address => ({
                      label: `${address.street} ${address.city}`,
                      code: `{\x22lat\x22:${address.addressLat}, \x22lng\x22:${address.addressLng}}`
                    }))
                  "
                  class="request-create-col-input"
                  name="selectCompanyAddress"
                  @input="setAddress"
                />
              </div>
            </div>
            <div>
              <h3 class="request-create-col-headline">Kenntnisse</h3>
              <Accordion>
                <template v-for="cat in allApplicantSkillCategories">
                  <div :key="cat.id" class="custom-accordion--item">
                    <accordion-item>
                      <template slot="accordion-trigger">
                        <h4 class="request-create-col-headline text-xl">
                          {{ cat.name }}
                        </h4>
                      </template>
                      <template slot="accordion-content">
                        <div
                          v-for="skill in cat.skills"
                          :key="skill.id"
                          class="request-create-col-input-wrapper"
                        >
                          <div class="request-create-col-label">
                            {{ skill.name }}
                          </div>
                          <data-input
                            v-if="skill.inputType == 'SELECT'"
                            :options="
                              skill.skillValues.map((skillValue, i) => ({
                                code: i,
                                label: skillValue.name
                              }))
                            "
                            class="request-create-col-input"
                            type="select"
                            name="skillValue"
                            :value="selectedSkillValues[skill.id]"
                            @input="e => updateSkillValue(skill, e, cat.name)"
                          ></data-input>
                          <data-input
                            v-else-if="skill.inputType == 'BOOLEAN'"
                            type="bool"
                            class="request-create-col-input"
                            name="skillValue"
                            :value="selectedSkillValues[skill.id]"
                            @input="e => updateSkillValue(skill, e, cat.name)"
                          ></data-input>
                        </div>
                      </template>
                    </accordion-item>
                  </div>
                </template>
              </Accordion>
            </div>
          </div>
          <button type="submit" class="request-job-create-button">
            <i class="fal fa-check-circle"></i>{{ submitButtonText }}
          </button>
        </div>
        <h4 v-if="matchingActive == false" @click="matchingActive = true">
          Matcher bearbeiten
        </h4>
      </div>
      <div
        class="request-col"
        :class="{
          large: matchingActive == true,
          hidden: matchingActive == false
        }"
      >
        <div class="request-create-col shadow-box">
          <h3 class="request-create-col-headline">
            Matching-Cockpit
            <div
              v-if="$apollo.queries.matchApplicants.loading"
              class="loading-animation"
            >
              <i class="fad fa-spinner-third"></i>
            </div>
            <span v-if="matchApplicants">{{ matchApplicants.total }}</span>
          </h3>
          <div class="user-matching-table-wrapper">
            <table
              v-if="matchApplicants && matchApplicants.results.length"
              class="user-matching-table"
            >
              <tr v-for="(result, i) in matchApplicants.results" :key="i">
                <template
                  v-if="
                    !request.favourites
                      .map(x => x.id)
                      .includes(result.applicant.id)
                  "
                >
                  <td width="62" class="table-progress">
                    <radial-progress-bar
                      :diameter="40"
                      :completed-steps="result.similarity * 100"
                      :total-steps="totalSteps"
                      :stroke-width="2"
                      :inner-stroke-width="2"
                      start-color="#89d549"
                      stop-color="#48c6f0"
                      inner-stroke-color="#ffffff"
                    >
                      <p class="progress-count">
                        {{ formatPercentage(result.similarity) }}
                      </p>
                    </radial-progress-bar>
                  </td>
                  <td>
                    <fa-user-prerendered />{{ result.applicant.firstName }}
                    {{ result.applicant.lastName }}
                  </td>
                  <td>
                    <fa-map-marker-alt-prerendered />

                    <template v-if="result.applicantAddress">
                      {{ result.applicantAddress.city }}
                    </template>
                  </td>
                  <td>
                    <fa-briefcase-prerenderred />{{
                      result.applicant.defaultProfile.wantedOccupation
                    }}
                  </td>
                  <td
                    width="40"
                    class="match-quick-view-action"
                    @click="openPreview(result.applicant.id)"
                  >
                    <fa-user-astronaut-prerendered />
                  </td>
                  <td
                    width="40"
                    class="match-action add"
                    @click="addApplicantToFavourites(result.applicant)"
                  >
                    <fa-ccheck-circle-prerendered />
                  </td>
                </template>
              </tr>
            </table>
          </div>

          <h3 class="request-create-col-headline">Meine Favoriten</h3>
          <table class="user-matching-table">
            <tr v-for="(applicant, i) in request.favourites" :key="i">
              <td width="62" class="table-progress">
                <radial-progress-bar
                  :diameter="40"
                  :completed-steps="applicantScores[applicant.id] * 100"
                  :total-steps="totalSteps"
                  :stroke-width="2"
                  :inner-stroke-width="2"
                  start-color="#89d549"
                  stop-color="#48c6f0"
                  inner-stroke-color="#ffffff"
                >
                  <p class="progress-count">
                    {{
                      applicantScores[applicant.id]
                        ? formatPercentage(applicantScores[applicant.id])
                        : "-"
                    }}
                  </p>
                </radial-progress-bar>
              </td>
              <td>
                <i class="far fa-user"></i>{{ applicant.firstName }}
                {{ applicant.lastName }}
              </td>
              <td>
                <i class="far fa-map-marker-alt"></i>
                <template
                  v-if="
                    request.favouritesAddresses &&
                      request.favouritesAddresses[i]
                  "
                >
                  {{ request.favouritesAddresses[i].city }} </template
                ><template v-else>
                  {{ applicantCities[applicant.id] }}
                </template>
              </td>
              <td>
                <i v-if="applicant.defaultProfile" class="fas fa-briefcase"></i
                >{{ applicant.defaultProfile.wantedOccupation }}
              </td>
              <td width="40" class="match-quick-view-action">
                <i class="fal fa-user-astronaut"></i>
              </td>
              <td
                width="40"
                class="match-action remove"
                @click="removeApplicantFromFavourites(applicant)"
              >
                <i class="fal fa-times"></i>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <ApplicantPreview />
  </form>
</template>
<script>
import DataInput from "@/components/ui/DataInput";
import RadialProgressBar from "vue-radial-progress";
import gql from "graphql-tag";
import ApplicantPreview from "./ApplicantPreview";
import Accordion from "@/components/ui/Accordion";
import AccordionItem from "@/components/ui/Accordion-Item";
import axios from "axios";
import FaBriefcasePrerenderred from "./faIcons/FaBriefcasePrerenderred.vue";
import FaUserAstronautPrerendered from "./faIcons/FaUserAstronautPrerendered.vue";
import FaMapMarkerAltPrerendered from "./faIcons/FaMapMarkerAltPrerendered.vue";
import FaUserPrerendered from "./faIcons/FaUserPrerendered.vue";
import FaCcheckCirclePrerendered from "./faIcons/FaCcheckCirclePrerendered.vue";

//TODO: Get these dynamically from backend/config
const primaryMatcherColumns = [
  "NoFearOfHeights",
  "WeldingGeneral",
  "TravelingNational",
  "TravelingInternational",
  "HardSoldering",
  "SoftSoldering"
];

export default {
  components: {
    DataInput,
    RadialProgressBar,
    ApplicantPreview,
    Accordion,
    AccordionItem,
    FaBriefcasePrerenderred,
    FaUserAstronautPrerendered,
    FaMapMarkerAltPrerendered,
    FaUserPrerendered,
    FaCcheckCirclePrerendered
  },
  emits: ["update", "submit"],
  props: {
    model: {
      required: true,
      type: Object
    },
    submitButtonText: {
      type: String,
      default: "Als Entwurf speichern"
    }
  },
  data() {
    return {
      selectedAddress: null,
      addressOptions: [],
      matchingActive: false,
      completedSteps: 67,
      totalSteps: 100,
      completedSteps2: 93,
      skillCategoriesUnfiltered: [],
      numberFormatter: new Intl.NumberFormat("de-DE", {
        style: "percent",
        maximumFractionDigits: 0
      }),
      request: {
        title: null,
        vacancyID: null,
        section: null,
        category: null,
        companyID: null,
        companyContactPartnerID: null,
        consultantID: null,
        userID: null,
        userGroupID: null,
        startsOn: null,
        duration: null,
        language: null,
        query: {
          fields: [],
          fieldGroups: []
        },
        vacancyTemplate: {
          occupationId: null,
          occupationString: null,
          applicantSkillJobTypeId: null,
          takeOverOption: null,
          hoursPerWeek: null,
          salary: null,
          workTimes: null
        },
        favourites: [],
        favouritesAddresses: []
      },
      selectedSkillValues: {},
      setupDone: false,
      skillValuesOutOfDate: false,
      applicantCities: {},
      applicantScores: {}
    };
  },
  computed: {
    contactPartnerQuery() {
      return gql`
        query CompanyContactPartners($search: String){
          companyContactPartners(search: $search, company:${
            this.request.companyID ? '"' + this.request.companyID + '"' : null
          }){
            results{
              firstName
              lastName
              id
            }
          }
        }
      `;
    }
  },
  watch: {
    model: {
      immidiate: true,
      deep: true,
      handler(value) {
        if (value) {
          if (!value.section) {
            value.section = "GEW";
          }
          if (!value.category) {
            value.category = "AÜ";
          }
          this.request = value;
          this.skillValuesOutOfDate = true;
          this.$emit("update", this.request);
        }
      }
    },
    allApplicantSkillCategories(value) {
      if (value) {
        this.$nextTick(() => this.updateSkillValues());
      }
    },
    skillValuesOutOfDate(value) {
      if (value) {
        this.$nextTick(() => this.updateSkillValues());
      }
    },
    "request.query": {
      deep: true,
      handler() {
        this.openMatching();
      }
    },
    "request.vacancyTemplate": {
      deep: true,
      handler() {
        this.openMatching();
      }
    },
    "request.startsOn": function() {
      this.openMatching();
    },
    request: {
      deep: true,
      handler(value) {
        if (
          value.category &&
          value.section &&
          value.companyID &&
          value.companyContactPartnerID
        ) {
          this.openMatching();
        }
      }
    },
    "request.vacancyTemplate.holidayAndChristmasBonus": function(value) {
      console.log(value);
    },
    "request.vacancyTemplate.applicantSkillJobTypeId": function(value) {
      if (value) {
        this.allApplicantSkillCategories = this.skillCategoriesUnfiltered.filter(
          cat => cat.group.jobTypes.map(x => x.id).includes(value)
        );
      } else {
        this.allApplicantSkillCategories = this.skillCategoriesUnfiltered;
      }
    }
  },
  methods: {
    formatPercentage(value) {
      let result = this.numberFormatter.format(value);
      result = result.replace(/\s+/, "");
      return result;
    },
    addressToOption(address) {
      console.log(address);
      return { label: "a", code: "a" };
    },
    setAddress(address) {
      if (address) {
        this.request.query.fields = insertOrReplaceTerm(
          this.request.query.fields,
          {
            name: "Address",
            term: {
              queryType: "fuzzy",
              stringValue: address
            }
          }
        );
      } else {
        this.request.query.fields = removeTerm(
          this.request.query.fields,
          "Address"
        );
      }
      console.log(address);
    },
    updateVacancy(value) {
      if (value) {
        console.log(value);
        this.request.vacancyID = value.id;
        this.updateOccupation(value.project.occupation);
        this.request.vacancyTemplate.hoursPerWeek = value.jobHoursLegacy;
        this.request.vacancyTemplate.salary = value.jobEarningsLegacy;
        this.request.vacancyTemplate.workTimes = value.jobTimes
          ? value.jobTimes.id
          : null;
        this.request.vacancyTemplate.takeOverOption = value.takeOverOption;
        this.request.vacancyTemplate.holidayAndChristmasBonus =
          value.holidayAndChristmasBonus;
      }
    },
    openMatching() {
      if (
        this.request.section &&
        this.request.category &&
        this.request.companyID &&
        this.request.companyContactPartnerID
      ) {
        this.matchingActive = true;
      }
    },
    openPreview(profileId) {
      this.$router.replace({
        name: "request.applicant.preview",
        params: {
          previewid: profileId,
          referer: this.$route.name,
          refererParams: this.$route.params
        }
      });
    },
    setCategory(value) {
      this.request.category = value;
      this.skillValuesOutOfDate = true;
    },
    async getApplicantCity(applicantID) {
      const { data } = await this.$apollo.query({
        query: gql`
          {
            applicant(id:"${applicantID}"){
              contactData{
                address{
                  city
                }
              }
            }
          }
        `
      });
      try {
        return data.applicant.contactData.address.city;
      } catch (e) {
        console.log(e);
        return "";
      }
    },
    updateOccupation(value) {
      this.request.vacancyTemplate.occupationId = value ? value.id : null;
      if (value) {
        this.request.vacancyTemplate.occupationString = value.name;
        console.log(value);
        this.request.query.fields = insertOrReplaceTerm(
          this.request.query.fields,
          {
            name: "JobTask",
            term: {
              stringValue: value.name,
              queryType: "fuzzy"
            }
          }
        );
        if (value.category) {
          this.request.query.fields = insertOrReplaceTerm(
            this.request.query.fields,
            {
              name: "OccupationCategories",
              term: {
                stringValue: value.category.id,
                queryType: "fuzzy"
              }
            }
          );
        }
      } else {
        this.request.query.fields = removeTerm(
          this.request.query.fields,
          "JobTask"
        );
        this.request.query.fields = removeTerm(
          this.request.query.fields,
          "OccupationCategories"
        );
      }
    },
    addApplicantToFavourites(applicant) {
      if (!this.request.favourites) this.request.favourites = [];
      for (let a of this.request.favourites) {
        if (a.id === applicant.id) {
          return;
        }
      }
      this.request.favourites.push(applicant);
      this.$emit("favouriteAdded", {
        newFavourites: this.request.favourites,
        applicant: applicant
      });
    },
    removeApplicantFromFavourites(applicant) {
      for (let i = 0; i < this.request.favourites.length; i++) {
        let f = this.request.favourites[i];
        if (f.id == applicant.id) {
          this.request.favourites.splice(i, 1);
          this.$emit("favouriteRemoved", {
            newFavourites: this.request.favourites,
            applicant: applicant
          });
          return;
        }
      }
    },
    setSection(value, skillTypeId) {
      this.request.section = value;
      this.request.vacancyTemplate.applicantSkillJobTypeId = skillTypeId;
    },
    updateSkillValues() {
      if (this.skillValuesOutOfDate) {
        for (let cat of this.allApplicantSkillCategories) {
          for (let skill of cat.skills) {
            const index = this.request.query.fields
              .map(f => f.name)
              .indexOf(skill.matcherColumn);
            if (index !== -1) {
              if (skill.inputType === "BOOLEAN") {
                this.updateSkillValue(
                  skill,
                  this.request.query.fields[index].term.stringValue === "true",
                  cat.name
                );
              } else if (skill.inputType === "SELECT") {
                this.updateSkillValue(
                  skill,
                  Math.round(
                    this.request.query.fields[index].term.numericValue *
                      skill.skillValues.length -
                      1
                  ),
                  cat.name
                );
              }
              continue;
            }
            for (const fieldGroup of this.request.query.fieldGroups) {
              const index = fieldGroup.fields
                .map(f => f.name)
                .indexOf(skill.matcherColumn);
              if (index !== -1) {
                if (skill.inputType === "BOOLEAN") {
                  this.updateSkillValue(
                    skill,
                    fieldGroup.fields[index].term.stringValue === "true",
                    cat.name
                  );
                } else if (skill.inputType === "SELECT") {
                  console.log(fieldGroup.fields[index].term.numericValue);
                  this.updateSkillValue(
                    skill,
                    Math.round(
                      fieldGroup.fields[index].term.numericValue *
                        skill.skillValues.length -
                        1
                    ),
                    cat.name
                  );
                }
                break;
              }
            }
          }
        }
        //Explanation below
        this.selectedSkillValues = Object.assign({}, this.selectedSkillValues);
        this.skillValuesOutOfDate = false;
      }
    },
    submitForm(event) {
      if (!event.submitter.classList.contains("request-job-create-button")) {
        return false;
      }
      this.$emit("update", this.request);
      this.$emit("submit", this.request);
      return false;
    },
    requestOpen() {
      if (this.matchingActive == true) {
        this.matchingActive = false;
      }
    },
    updateSkillValue(skill, value, category) {
      if (value !== null && value !== undefined && value !== false) {
        const field = {
          term: matcherTermFromValue(skill, value),
          name: skill.matcherColumn
        };
        if (primaryMatcherColumns.includes(field.Name)) {
          this.request.query.fields = insertOrReplaceTerm(
            this.request.query.fields,
            field
          );
        } else {
          if (
            !this.request.query.fieldGroups.map(x => x.name).includes(category)
          ) {
            this.request.query.fieldGroups.push({
              name: category,
              fields: []
            });
          }
          let fieldGroup = this.request.query.fieldGroups.filter(
            x => x.name === category
          )[0];
          fieldGroup.fields = insertOrReplaceTerm(fieldGroup.fields, field);
        }
      } else {
        if (primaryMatcherColumns.includes(skill.matcherColumn)) {
          this.request.query.fields = removeTerm(
            this.request.query.fields,
            skill.matcherColumn
          );
        } else if (
          this.request.query.fieldGroups.map(x => x.name).includes(category)
        ) {
          let fieldGroup = this.request.query.fieldGroups.filter(
            x => x.name === category
          )[0];
          fieldGroup.fields = removeTerm(
            fieldGroup.fields,
            skill.matcherColumn
          );
        }
      }

      /*From the docs : 
          "Due to the limitations of modern JavaScript (and the abandonment of Object.observe),
          Vue cannot detect property addition or deletion.
          Since Vue performs the getter/setter conversion process during instance initialization,
          a property must be present in the data object in order for Vue to convert it and make it reactive."
        If you just do a normal assignment the compiler will optimize it away
      */
      let temp = this.selectedSkillValues;
      temp[skill.id] = value;
      this.selectedSkillValues = Object.assign({}, temp);
    }
  },
  apollo: {
    me: {
      query: gql`
        query Me {
          me {
            id
            group {
              id
            }
            consultant {
              id
            }
          }
        }
      `,
      update(data) {
        if (!this.request.userID) {
          this.request.userID = data.me.id;
        }
        if (!this.request.consultantID) {
          this.request.consultantID = data.me.consultant.id;
        }
        if (!this.request.userGroupID) {
          this.request.userGroupID = data.me.group.id;
        }
        return data.me;
      }
    },
    allApplicantSkillCategories: {
      query: gql`
        query AllApplicantSkillCategories {
          allApplicantSkillCategories {
            skills {
              id
              name
              sort
              skillValues {
                id
                name
                sort
              }
              inputType
              matcherColumn
            }
            group {
              jobTypes {
                id
              }
            }
            id
            name
            sort
          }
        }
      `,
      update(data) {
        this.skillCategoriesUnfiltered = data.allApplicantSkillCategories
          .map(cat => {
            cat.skills = cat.skills
              .filter(skill => skill.matcherColumn)
              .filter(skill => skill.skillValues)
              .map(skill => {
                skill.skillValues.sort((x, y) => {
                  if (x.sort > y.sort) {
                    return -1;
                  } else if (x.sort < y.sort) {
                    return 1;
                  }
                  return 0;
                });
                return skill;
              });
            return cat;
          })
          .filter(cat => cat.skills.length > 0);
        return this.skillCategoriesUnfiltered;
      }
    },
    companyAddresses: {
      query: gql`
        query CompanyAddresses($company: ID!) {
          companyAddresses(company: $company) {
            results {
              id
              street
              city
              zip
              addressLat
              addressLng
              country
            }
          }
        }
      `,
      variables() {
        return {
          company: this.request.companyID
        };
      },
      skip() {
        return !this.request.companyID;
      },
      async update(data) {
        console.log(data);
        let $this = this;
        let result = await Promise.all(
          data.companyAddresses.results.map(async function(address) {
            if (address.addressLat == null || address.addressLng == null) {
              let config = {
                method: "get",
                url: `https://maps.googleapis.com/maps/api/geocode/json`,
                headers: {},
                params: {
                  address: searchStringFromAddress(address),
                  key: process.env.VUE_APP_MAPS_API_KEY
                }
              };
              let result = await axios(config);
              console.log(result);
              let lat = result.data.results[0].geometry.location.lat;
              let lng = result.data.results[0].geometry.location.lng;
              let variables = {
                id: address.id,
                input: {
                  addressLat: lat,
                  addressLng: lng
                }
              };
              $this.$apollo.mutate({
                mutation: gql`
                  mutation SetCompanyAddressCoordinates(
                    $id: ID!
                    $input: CompanyAddressCoordinatesInput!
                  ) {
                    setCompanyAddressCoordinates(id: $id, input: $input) {
                      id
                    }
                  }
                `,
                variables
              });
              address.addressLat = lat;
              address.addressLng = lng;
              return address;
            }
            return address;
          })
        );
        this.selectedAddress = null;
        this.addressOptions = result;
      }
    },
    matchApplicants: {
      query: gql`
        query MatchAppplicants($input: MatcherRequestInput!) {
          matchApplicants(input: $input, page: 1, size: 80, cutoff: 0.7) {
            page
            results {
              applicant {
                id
                firstName
                lastName
                occupationField {
                  id
                  name
                }
                group {
                  id
                  name
                }
                defaultProfile {
                  wantedOccupation
                }
              }
              applicantAddress {
                city
              }
              similarity
            }
            total
          }
        }
      `,
      variables() {
        let input = Object.deleteIdsAndTypes(this.request);
        delete input["favourites"];
        delete input["favouritesAddresses"];
        input.title = input.title || "t";
        return {
          input
        };
      },
      skip() {
        return !this.matchingActive;
      }
    },
    scoreApplicants: {
      query: gql`
        query ScoreAppplicants(
          $input: MatcherRequestInput!
          $applicants: [ID!]!
        ) {
          scoreApplicants(input: $input, applicants: $applicants) {
            applicant {
              id
              defaultProfile {
                wantedOccupation
              }
            }
            applicantAddress {
              city
            }
            similarity
          }
        }
      `,
      variables() {
        let input = Object.deleteIdsAndTypes(this.request);
        delete input["favourites"];
        delete input["favouritesAddresses"];
        input.title = input.title || "t";
        return {
          input,
          applicants: this.request.favourites.map(x => x.id)
        };
      },
      update(data) {
        data = data.scoreApplicants;
        let newApplicantCities = {};
        let newApplicantScores = {};
        for (const qr of data) {
          newApplicantCities[qr.applicant.id] = qr.applicantAddress.city;
          newApplicantScores[qr.applicant.id] = qr.similarity;
        }
        this.applicantCities = newApplicantCities;
        this.applicantScores = newApplicantScores;
      },
      skip() {
        return !this.matchingActive;
      }
    }
  }
};

function matcherTermFromValue(skill, value) {
  if (skill.inputType === "SELECT") {
    const val = (value + 1) / skill.skillValues.length;
    console.log(val);
    return {
      numericValue: val,
      stringValue: String(val),
      queryType: "fuzzy"
    };
  } else if (skill.inputType === "BOOLEAN") {
    return {
      numericValue: value ? 1 : 0,
      stringValue: String(!!value),
      //TODO: maybe change this to fuzzy as well
      queryType: "fuzzy"
    };
  }
  throw new Error(
    `Invalid input type: ${skill.inputType} (Valid input types are SELECT and BOOLEAN)`
  );
}

function insertOrReplaceTerm(fields, field) {
  for (let f of fields) {
    if (f.name === field.name) {
      f.term = field.term;
      return fields;
    }
  }
  fields.push(field);
  return fields;
}
function removeTerm(fields, term) {
  const index = fields.map(x => x.name).indexOf(term);
  if (index === -1) {
    return fields;
  }
  fields.splice(index, 1);
  return fields;
}

function searchStringFromAddress(address) {
  return `${address.street} ${address.zip} ${address.city}, ${address.country}`;
}
</script>
<style scoped>
.loading-animation > * {
  display: inline-block !important;
  animation: rotate 1s linear 0s infinite;
}
.loading-animation {
  display: inline-block;
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}
</style>
